module.exports = __webpack_public_path__ + "static/media/FacistBoard_medium_3.3bfaa350.png";